import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-error',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd"
            d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25c5.9371 0 10.75 4.81294 10.75 10.75 0
            5.9371-4.8129 10.75-10.75 10.75-5.93706 0-10.75-4.8129-10.75-10.75ZM12 7.5c.5523 0
            1 .44772 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-4c0-.55228.4477-1 1-1Zm0 7c-.5523
            0-1 .4477-1 1s.4477 1 1 1h.009c.5523 0 1-.4477 1-1s-.4477-1-1-1H12Z"
            clip-rule="evenodd" />
    </svg>
  `
})
export class IconErrorComponent {
  size: InputSignal<number> = input<number>(24);
}
